import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../../../../components/fields/abstract-field.class';
import {UserService} from '../services/user.service';

@Component({
    selector: 'properties-select',
    templateUrl: 'properties-select.component.html',
    styleUrls: ['./properties-select.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PropertiesSelectComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => PropertiesSelectComponent), multi: true }
    ]
})
export class PropertiesSelectComponent extends AbstractFieldClass implements OnInit {
    @Input('propertyFilter') _propertyFilter  = null;
    @Input('value') _value: any = [];
    @Input('noTitle') noTitle = false;
    @Output() onItemSelect = new EventEmitter();
    multiselectSettings = {
        singleSelection: false,
        text: 'Select Properties',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        maxHeight: 150,
        enableSearchFilter: true
    };
    prevSelected = [];

    constructor(public userService: UserService) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.userService.getBuildings();
    }

    get buildings() {
        return [...this.userService.multiselectBuildings.filter(item =>
            !item.disabled && (!this._propertyFilter || this._propertyFilter.corporationNumberId == item.corporationNumber)
        )];
    }

    validator(value: any): boolean {
        return true;
    }

    public onSelect(selectedItem): void {
        setTimeout(() => {
            this.userService.multiselectBuildings.find(item => {
                return Number(item.id) === Number(selectedItem.id);
            }).disabled = true;
            this.onItemSelect.emit(selectedItem);
        }, 300);
    }

    public onDeselect(selectedItem): void {
        const current = this.userService.multiselectBuildings.find(item => {
            return Number(item.id) === Number(selectedItem.id);
        });
        if (current) current.disabled = false;
        this.onItemSelect.emit(selectedItem);
    }

    public onSelectAll(selectedItems): void {
        this.prevSelected = selectedItems;
        this.userService.multiselectBuildings.map(item => {
            return item.disabled = true;
        });
        this.onItemSelect.emit(selectedItems);
    }

    public onDeselectAll(selectedItems): void {
        this.prevSelected.forEach(selected => {
            this.userService.multiselectBuildings.map(item => {
                if (selected.id == item.id) {
                    return item.disabled = false;
                }
                return item;
            });
        });
        this.onItemSelect.emit(selectedItems);
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/admin/user/properties-select/properties-select.component.ts